<template>
  <div class="expo-msg-container">
    <div class="btn_wrap">
      <div v-for="(item,index) in btnList" :key="index" :class="['btn_item',{'act_item':activeIndex==index}]" @click="handelClick(index)">
        <div>
          <img :src="item.iconUrl" alt :class="[{'car_item':index==4}]" />
        </div>
        <span class="media_font_size_30 mt-40">{{item.title}}</span>
        <span class="media_font_size_30">{{ item.en }}</span>
      </div>
    </div>
    <default-service />
    <!-- <service v-if="activeIndex==1" />
    <dataDown v-if="activeIndex==3" />
    <traffic v-if="activeIndex==4" />
    <div v-if="activeIndex==0||activeIndex==2" class="default_show">暂无相关内容，敬请期待</div> -->
  </div>
</template>

<script>
import defaultService from "./components/service"
import dataDown from "./components/dataDown"
import traffic from "./components/traffic"
export default {
  components:{
    defaultService,
    dataDown,
    traffic
  },
  data() {
    return {
      activeIndex:1,
      deviceWidth:document.body.clientWidth,
      btnList: [
        {
          title: "日程安排",
          iconUrl: require("../../assets/img/ic_schedule.png"),
          url: "/schedule?tab=1",
          simpName:"日程安排",
          en:"Schedule"
        },
        {
          title: "交通指南",
          iconUrl: require("../../assets/img/ic_traffic.png"),
          url: "/schedule?tab=2",
          simpName:"交通指南",
          en:"Transportation"
        },
        {
          title: "购票方式",
          iconUrl: require("../../assets/img/ic_ticket.png"),
          url: "/schedule?tab=4",
          simpName:"购票方式",
          en:"Ticket"
        },
        {
          title: "资料下载",
          iconUrl: require("../../assets/img/ic_download.png"),
          url:"/exhibitor?tab=4",
          simpName:"资料下载",
          en:"Download"
        },
        {
          title: "媒体证",
          iconUrl: require("../../assets/img/ic_media.png"),
          url:"/mediaApply",
          simpName:"媒体证",
          en:"Media Pass"
        }
      ]
    };
  },
  methods:{
    handelClick(index){
      this.$router.push(this.btnList[index].url)
    }
  },
  mounted(){
    console.log(this.deviceWidth)
  }
};
</script>

<style lang="scss">
.expo-msg-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  
  .btn_wrap {
    display: flex;
    align-items: center;
    width: 1200px;
    justify-content: space-between;
    margin: 100px 0px;
    .btn_item {
      width: 200px;
      height: 320px;
      background: #39363c;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      > div {
        width: 80px;
        height: 80px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        > img {
          width: 80px;
          height: 80px;
        }
        .car_item {
          width: 86px;
          height: 64px;
        }
      }

      > span {
        color: #fff;
        font-size: 20px;
        line-height: 30px;
      }
    }
    .btn_item:hover{
      background: linear-gradient(to top right, #0075fe 0%, #42abff 100%);
      transition:  2s;
    }
  }
}
.default_show{
  color: #fff;
  font-size: 32px;
}
</style>


// WEBPACK FOOTER //
// expoMsg.vue?dde5fbe4